import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "help-box-section section-margin"
};
const _hoisted_2 = {
  class: "box-width d-flex justify-content-center"
};
const _hoisted_3 = {
  class: "help-box-card"
};
const _hoisted_4 = {
  class: "inner-card-details"
};
const _hoisted_5 = {
  class: "help-links-elements mt-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[3] || (_cache[3] = _createElementVNode("h2", null, "Got Questions?", -1)), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("h6", null, "We’re happy to share more details! Learn everything about how G1G works.", -1)), _createElementVNode("div", _hoisted_5, [_cache[1] || (_cache[1] = _createStaticVNode("<a href=\"tel:408-478-9990\" data-v-0fbfaec3><div class=\"link-element\" data-v-0fbfaec3><div class=\"circle-bg\" data-v-0fbfaec3><svg height=\"38.155\" viewBox=\"816 2258 31.477 38.155\" width=\"31.477\" xmlns=\"http://www.w3.org/2000/svg\" data-v-0fbfaec3><g data-name=\"phone-action-question-1\" data-v-0fbfaec3><path d=\"M837.478 2289.155h-21\" data-name=\"Line 301\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M827.198 2292.837c0 .23-.186.415-.415.415h0a.415.415 0 0 1-.415-.415h0c0-.229.186-.414.415-.414\" data-name=\"Path 831\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M827.198 2292.837h0\" data-name=\"Line 302\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M826.783 2292.423c.229 0 .415.185.415.414\" data-name=\"Path 832\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M826.783 2292.423h0\" data-name=\"Line 303\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M837.566 2281.225v11.612a3.318 3.318 0 0 1-3.318 3.318h-14.93a3.318 3.318 0 0 1-3.318-3.318v-31.52a3.318 3.318 0 0 1 3.318-3.317h9.124\" data-name=\"Path 833\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M827.478 2268.055a10 10 0 1 1 0 .1z\" data-name=\"Ellipse 197\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M834.456 2265.535a3.11 3.11 0 1 1 3.11 3.11v1.66\" data-name=\"Path 834\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path><path d=\"M837.566 2273.622a.415.415 0 1 1 0 .83.415.415 0 0 1 0-.83\" data-name=\"Path 835\" fill=\"transparent\" stroke=\"#007bc6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" data-v-0fbfaec3></path></g></svg></div><h6 data-v-0fbfaec3>Call</h6></div></a>", 1)), _createVNode(_component_router_link, {
    to: "/faq"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("div", {
      class: "link-element"
    }, [_createElementVNode("div", {
      class: "circle-bg"
    }, [_createElementVNode("svg", {
      height: "38.155",
      viewBox: "943 2258 32.72 38.155",
      width: "32.72",
      xmlns: "http://www.w3.org/2000/svg"
    }, [_createElementVNode("g", {
      "data-name": "reception-bell-call"
    }, [_createElementVNode("path", {
      d: "M964.567 2296.155a1.659 1.659 0 0 0 1.64-1.932 11.778 11.778 0 0 0-23.184 0 1.659 1.659 0 0 0 1.637 1.932h19.907Z",
      "data-name": "Path 845",
      fill: "transparent",
      stroke: "#007bc6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }), _createElementVNode("path", {
      d: "M956.692 2258c-.063.54.07 1.084.374 1.535l4.285 6.506-6.138 7.838a2.498 2.498 0 0 0 .436 3.5 2.472 2.472 0 0 0 3.465-.41l11.263-14.394c-.538 6.07.428 7.693 1.733 8.715 1.306 1.022 2.655-.694 2.767-2.067l.843-11.223",
      "data-name": "Path 846",
      fill: "transparent",
      stroke: "#007bc6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }), _createElementVNode("path", {
      d: "M955.097 2284.155v-3",
      "data-name": "Line 304",
      fill: "transparent",
      stroke: "#007bc6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }), _createElementVNode("path", {
      d: "M958.76 2281.225h-8.295",
      "data-name": "Line 305",
      fill: "transparent",
      stroke: "#007bc6",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    })])])]), _createElementVNode("h6", null, "FAQs")], -1)])),
    _: 1
  })])])])])]);
}